<template>
  <div v-if="widget.visible" :id="widget.id" ref="widget" class="ui-widget-body relative">
    <div class="widget-tag absolute top-0 left-0 px-2 py-1 text-white z-20 rounded-br" :class="tagClassName">
      {{ $t(`model.${menuInfo.title}`) }}
    </div>
    <div v-if="showTools" class="tools-area flex items-center z-20">
      <div
        class="fun-item move-btn w-[32px] h-[32px] text-black rounded-full bg-textColor-6 hover:bg-white cursor-row-resize flex items-center justify-center">
        <i class="el-icon-rank text-18"></i>
      </div>
      <div v-if="!isDefault"
        class="fun-item ml-4 w-[32px] h-[32px] text-black rounded-full bg-textColor-6 hover:bg-white cursor-pointer flex items-center justify-center"
        @click="handleShowDeleteDialog">
        <i class="el-icon-delete text-18"></i>
      </div>
    </div>
    <add-block v-if="showAddBlock" :model="model" :selected="selected" :can-drag="canDrag" :index="index"
      :widget="widget" @add="onWidgetAdd" @show-add-block="handleShowAddBlock" />
    <div class="widget-wrap" :class="widgetClassName">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue'
import addBlock from "~/components/addBlock"
import { WidgetModelNames } from '~/enums/siteEnum'

const props = defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
  canDrag: {
    type: Boolean,
    default: false
  },
  isDefault: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
    default: 0,
  },
  widget: {
    type: Object,
    default() {
      return {
        getMenuInfo() {
          return {
            draggable: true
          }
        }
      }
    }
  },
  model: {
    type: Object,
    required: true,
    default() {
      return {
        getCanAddWidget() {
        }
      }
    }
  }
})

const emit = defineEmits(['add', 'show-add-block'])

const show = ref(false)

const { proxy } = getCurrentInstance()

const menuInfo = computed(() => {
  return props.widget?.getMenuInfo() || {}
})

watch(() => props.selected, () => {
  show.value = false
})

const handleShowDeleteDialog = () => {
  proxy?.SiteMenu?.openDeleteBlockDialog()
}

const onWidgetAdd = (model, index) => {
  emit('add', model, index)
}

const handleShowAddBlock = (index) => {
  emit('show-add-block', index)
}

const ignore = [WidgetModelNames.CyclePackageWidgetModel, WidgetModelNames.DialogCollectionWidgetModel]
const showAddBlock = computed(() => {
  return !ignore.includes(props.widget?.name)
})
const tagClassName = computed(() => {
  if (props.selected && !ignore.includes(props.widget?.name)) {
    return 'block'
  } else {
    return null
  }
})

const showTools = computed(() => {
  if (ignore.includes(props.widget?.name)) {
    return false
  } else {
    return props.canDrag && (props.selected && !show.value) && proxy.$store.getters.isDesktop
  }
})

const widgetClassName = computed(() => {
  if (props.selected && !ignore.includes(props.widget?.name)) {
    return 'active'
  }
  return null
})

//
// const addWidgetByIndex = (item) => {
//   props.model.addWidgetByIndex(item.model, props.index + 1)
//   show.value = false
// }
</script>

<style lang="less" scoped>
.ui-widget-body {
  position: relative;

  .widget-tag {
    background-color: var(--primary-color);
    display: none;
    font-size: 12px;
    font-weight: 500;
    box-shadow: var(--shadow-sm);
    backdrop-filter: blur(4px);
  }

  &:hover {
    .widget-tag {
      display: block;
      animation: fadeIn 0.2s ease-out;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tools-area {
    position: absolute;
    top: 40px;
    left: 40px;
    cursor: pointer;

    .fun-item {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: var(--shadow-md);
      border: 1px solid rgba(0, 0, 0, 0.05);
      color: var(--text-color);
      background-color: #fff;

      i {
        transition: transform 0.3s ease;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-lg);
        color: var(--primary-color);
        background-color: #fff;

        i {
          transform: scale(1.1);
        }
      }

      &:active {
        transform: translateY(0);
        box-shadow: var(--shadow-sm);
      }

      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(63, 84, 242, 0.3), 0 6px 18px rgba(63, 84, 242, 0.18);
      }

      &.move-btn {
        cursor: move;
      }
    }
  }

  .widget-wrap {
    border: 2px solid transparent;
    transition: border-color 0.2s ease;
    border-radius: 4px;

    &:hover {
      border: 2px solid rgba(var(--primary-color-rgb), 0.5);
    }

    &.active {
      border: 2px solid var(--primary-color);
      box-shadow: 0 0 0 4px rgba(var(--primary-color-rgb), 0.1);
    }
  }
}
</style>
